<template>
  <div class="modal fade" :id="'kt_modal_' + id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <form @submit.prevent="updateAnswerType" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('qvct_survey.answerChoice.updated')}}</h5>

            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">

              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <Select2
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-answer-type`"
                  :multiple="false"
                  :parent-id="'#kt_modal_' + id"
                  :label="$t('qvct_survey.answerType.name')"
                  labelClass="form-label fs-6 text-black"
                  :selectClass="'form-select form-control-sm form-select-solid'"
                  :isRequired="true"
                  v-model="formData.answer_type_id"
                  :IsInputGroup ="true"
                  icon="bi bi-plus"
                  :clickAddon="openCreateAnswerTypeModal"
              >
                <option v-for="type in answerTypes" :key="type.id" :value="type.id">
                  {{ type.name }}
                </option>
              </Select2>

              <Input
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-choice-label`"
                  type="text"
                  :label="$t('qvct_survey.answerChoice.label')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('qvct_survey.answerChoice.label_placeholder')"
                  v-model="formData.label"
              />

              <Input
                  containerClass="col-6 mt-auto mb-5"
                  :name="`${id}-choice-percentage`"
                  type="number"
                  :label="$t('qvct_survey.answerChoice.percentage')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  v-model.number="formData.percentage"
                  :min="0"
                  :max="100"
              />

              <Input
                  containerClass="col-6 mt-auto mb-5"
                  :name="`${id}-choice-order`"
                  type="number"
                  :label="$t('qvct_survey.answerChoice.order')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="false"
                  :placeholder="$t('qvct_survey.answerChoice.order_placeholder')"
                  v-model.number="formData.order"
              />

            </div>

            <CreateQvctAnswer
                id="create_qvct_answer"
                @reload="reload"
            />

          </div>

          <div class="modal-footer">
            <Button btn-class="btn-sm me-2" type="cancel" btn-text="button.close" size="7px 30px" @click="closeModal"/>
            <Button btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :isLoading="processing"/>
          </div>
        </div>
      </form>
    </div>
  </div>


</template>

<script setup>

import {ref, defineEmits, defineProps, onMounted, computed} from "vue";
import Input from "@/components/Input.vue";
import {useLocales} from "@/composables/locales";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText.vue"
import Button from "@/components/Button.vue"
import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import Select2 from "@/components/Select2.vue";
import CreateQvctAnswer from "@/Modules/Qvct/components/CreateQvctAnswerType.vue";

const store = useStore()
const {locale} = useLocales()
const emit = defineEmits(['reload'])

const props = defineProps({
  id: {
    type: String,
    default: 'kt_modal_'
  },
  editForm : {
    type: Object,
    default: () => ({
      answer_type_id: "",
      label: "",
      percentage: 0,
      order: null
    })
  },


})


const answerTypes = computed(() => store.getters['qvctAnswersType/getQvctAnswersType']);
const processing = ref(false)
const formData = ref(props.editForm)


function openCreateAnswerTypeModal(){
  $('#kt_modal_create_qvct_answer').modal('toggle')
}

function reload(answerType){
  loadData();
  formData.value.answer_type_id = answerType;
}
function closeModal(){
  $("#kt_modal_" + props.id).modal('hide')
}



function updateAnswerType() {
  processing.value = true

  store.dispatch('qvctAnswersChoise/updateQvctAnswerChoice', formData.value)
      .then(res => {
        loadData()
        $('#'+props.id).modal('toggle')
        window.toastr['success'](i18n.global.t("notification.answerChoice_updated"))
        emit('reload')
        closeModal()
      })
      .finally(() => processing.value = false)
}

function loadData() {
  Promise.all([
    store.dispatch('qvctAnswersType/loadQvctAnswerType'),
  ])
}

onMounted(() => {
  loadData()
})


</script>

<style scoped></style>
